export default __webpack_public_path__ + "static/media/exportdata.cd4eeb90.png";